import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Apollo } from "apollo-angular";
import { firstValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { RequestOptions } from "../../../../config/request-options";
import { BulkDownloadInvoicesRequest } from "../../../../models/request/bulk-download-invoices-request.model";
import { BooleanResponseWrapper } from "../../../../models/response/boolean-response-wrapper.model";
import { BULK_DOWNLOAD_INVOICES } from "../../../../gql/secure/v1/invoice/bulk-download";

/**
 * This file is generated from the metadata.json file. 
 * ** DO NOT edit this file manually **
 *
 * @example
 * ```
 * import { InvoiceBulkDownloadApiService } from '@aiwyn-ai/gql-api/services/secure/v1/invoice/bulk-download-api.service';
 *
 * service = inject(InvoiceBulkDownloadApiService);
 * ```
 */
@Injectable({ providedIn: 'root' })
export class InvoiceBulkDownloadApiService {
    private readonly defaultBaseUrl: string = '/api';

    constructor(readonly apollo: Apollo, readonly http: HttpClient) {
    }

    /**
     * @param {BulkDownloadInvoicesRequest} bulkDownloadInvoicesRequest - The bulkDownloadInvoicesRequest to BULK_DOWNLOAD_INVOICES.
     * @param {RequestOptions} options - Optional configuration to use REST instead of GraphQL.
     * @returns {Promise<BooleanResponseWrapper>} A promise that resolves to the booleanResponseWrapper.,
     *
     * @example
     * ```
     * // Using GraphQL (default)
     * const result = await this.bulkDownloadInvoices(bulkDownloadInvoicesRequest);
     *
     * // Using REST
     * const result = await this.bulkDownloadInvoices(bulkDownloadInvoicesRequest, { useRest: true });
     * ```
     */
    async bulkDownloadInvoices(bulkDownloadInvoicesRequest: BulkDownloadInvoicesRequest, options?: RequestOptions): Promise<BooleanResponseWrapper> {
        if (options?.useRest) {
            return this._bulkDownloadInvoicesRest(bulkDownloadInvoicesRequest, options.baseUrl);
        }
        return this._bulkDownloadInvoicesGraphQL(bulkDownloadInvoicesRequest);
    }

    private async _bulkDownloadInvoicesGraphQL(bulkDownloadInvoicesRequest: BulkDownloadInvoicesRequest): Promise<BooleanResponseWrapper> {
        return firstValueFrom(this.apollo.mutate({
            mutation: BULK_DOWNLOAD_INVOICES,
            variables: { bulkDownloadInvoicesRequest },
        }).pipe(
            map((response: any) => response.data.BulkDownloadInvoices),
        ));
    }

    private async _bulkDownloadInvoicesRest(bulkDownloadInvoicesRequest: BulkDownloadInvoicesRequest, baseUrl?: string): Promise<BooleanResponseWrapper> {
        const url = `${baseUrl ?? this.defaultBaseUrl}/secure/v1/invoice/bulk-download`;
        return firstValueFrom(
            this.http.post<BooleanResponseWrapper>(url, bulkDownloadInvoicesRequest)
        );
    }
}
